"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingDockScanEventScanType = void 0;
exports.LoadingDockScanEventScanType = {
    ARRIVAL: 'ARRIVAL',
    DEPARTURE: 'DEPARTURE',
    LINK_TO_BOL: 'LINK_TO_BOL'
};
//# sourceMappingURL=loading-dock-scan-event-scan-type.js.map